(function () {
  const injectMobileStyles = () => {
    if (document.getElementById('prd-tabs-mobile-styles')) return;

    const style = document.createElement('style');
    style.id = 'prd-tabs-mobile-styles';
    style.innerHTML = `
      @media screen and (max-width: 719px) {
        .pxu-tabs {
          display: flex !important;
          flex-direction: column !important;
          height: auto !important;
        }

        .pxu-tabs .tab-label {
          order: 1 !important;
          width: 100% !important;
          display: flex !important;
          justify-content: center !important;
          align-items: center !important;
          padding: 1.25rem !important;
          margin: 0 !important;
          border: 1px solid #e5e5e5 !important;
          border-bottom: none !important;
          background-color: #f9f9f9 !important;
          color: #333 !important;
          font-weight: 600 !important;
          text-transform: capitalize !important;
          cursor: pointer !important;
          height: auto !important;
          min-height: 54px !important;
          position: relative !important;
        }

        /* Hide accordion symbols */
        .pxu-tabs .tab-label::before,
        .pxu-tabs .tab-label::after {
          display: none !important;
          content: none !important;
        }

        .pxu-tabs .tab-checkbox:checked + .tab-label {
          background-color: #E2C417 !important;
          color: #FFFFFF !important;
          border-color: #E2C417 !important;
          z-index: 2 !important;
        }

        .pxu-tabs .tab-panel {
          order: 2 !important;
          width: 100% !important;
          display: none !important;
          padding: 1.5rem !important;
          border: 1px solid #e5e5e5 !important;
          border-top: none !important;
          background: #fff !important;
          max-height: none !important;
          opacity: 1 !important;
          visibility: visible !important;
          overflow: visible !important;
          transition: none !important;
        }
          .pxu-tabs .tab-panel img{
          height: 40px;
          }

        .pxu-tabs .tab-checkbox:checked + .tab-label + .tab-panel {
          display: block !important;
        }

        .pxu-tabs .tab-label:nth-last-of-type(1) {
          border-bottom: 1px solid #e5e5e5 !important;
        }
        .pxu-tabs .tab-checkbox:checked + .tab-label:nth-last-of-type(1) {
          border-bottom-color: #E2C417 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const isMobile = () => window.innerWidth < 720;

  const handleGlobalClick = (e) => {
    if (!isMobile()) return;

    const label = e.target.closest('.tab-label');
    if (!label) return;

    // Check if label belongs to pxu-tabs
    const container = label.closest('.pxu-tabs');
    if (!container) return;

    const forId = label.getAttribute('for');
    if (!forId) return;

    const targetInput = document.getElementById(forId);
    if (!targetInput || !targetInput.classList.contains('tab-checkbox')) return;

    // Strict radio behavior: manually manage checked status
    e.preventDefault();
    e.stopPropagation();

    // If already checked, do nothing (keep it open)
    if (targetInput.checked) return;

    // Uncheck all other inputs in the same container
    const allInputs = container.querySelectorAll('.tab-checkbox');
    allInputs.forEach(input => {
      input.checked = (input === targetInput);
    });

    // Trigger change event
    targetInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const initActiveTabs = () => {
    if (!isMobile()) return;
    const containers = document.querySelectorAll('.pxu-tabs');
    containers.forEach(container => {
      const inputs = Array.from(container.querySelectorAll('.tab-checkbox'));
      if (inputs.length > 0 && !inputs.some(input => input.checked)) {
        inputs[0].checked = true;
      }
    });
  };

  const setup = () => {
    injectMobileStyles();
    initActiveTabs();

    if (!window._prdTabsGlobalInit) {
      document.addEventListener('click', handleGlobalClick, true);
      window._prdTabsGlobalInit = true;
    }
  };

  // Run immediately and on common event cycles
  setup();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  }

  // Periodic check to ensure styles and active tabs are correct (handles Shopify Section API)
  setInterval(setup, 2000);

  // MutationObserver for faster response to DOM changes
  new MutationObserver(setup).observe(document.body, { childList: true, subtree: true });

  // Handle resize
  window.addEventListener('resize', setup);
})();
